var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCause7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.25,51c0-5.24-4.26-9.5-9.5-9.5s-9.5,4.26-9.5,9.5c0,4.55,3.22,8.36,7.5,9.28v5.72c0,9.92-8.07,18-18,18s-18-8.08-18-18v-10.5h2.02c10.47,0,18.98-9.17,18.98-20.44v-14.14c0-4.1-3.14-7.43-7-7.43h-4.13c-.63-.91-1.68-1.5-2.87-1.5-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5c1.19,0,2.23-.59,2.87-1.5h4.13c1.65,0,3,1.54,3,3.43v14.14c0,9.06-6.72,16.44-14.98,16.44h-8.04c-8.26,0-14.98-7.37-14.98-16.44v-14.14c0-1.89,1.35-3.43,3-3.43h4.13c.63.9,1.68,1.5,2.87,1.5,1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5c-1.19,0-2.23.6-2.87,1.5h-4.13c-3.86,0-7,3.33-7,7.43v14.14c0,11.27,8.51,20.44,18.98,20.44h2.02v10.5c0,12.13,9.87,22,22,22s22-9.87,22-22v-5.72c4.28-.92,7.5-4.73,7.5-9.28ZM76.75,57.5c-3.58,0-6.5-2.92-6.5-6.5s2.92-6.5,6.5-6.5,6.5,2.92,6.5,6.5-2.92,6.5-6.5,6.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.75,
    cy: 51,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause7);
export default __webpack_public_path__ + "static/media/cause_7.99044ced2bb18ce5b81d8df4b043d007.svg";
export { ForwardRef as ReactComponent };